import { createContext } from 'react';
import type { RecoConfig } from '@melio/payments-recon-api-client-ts';

export const RecoConfigContext = createContext<RecoConfig>(
  undefined as unknown as RecoConfig
);
